// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HYay","rootMobile":"styles_rootMobile__1vSKh"};